module.exports = __webpack_public_path__ + "assets/img/in_(6).30053f56.gif";